import addInitialTemplate from './addInitialTemplate';
import { registerButton } from './buttonRegistryFactory';
import createDoubleSignatureRibbonButton from './createDoubleSignatureRibbonButton';
import createSignatureRibbonButton from './createSignatureRibbonButton';
import createTemplatesButton from './createTemplatesRibbonButton';
import lineHeightSelector from './lineHeightSelector';
import recordButton from './recordButton';
import translateReport from './translateReport';
import uploadAudioButton from './uploadAudioButton';

registerButton('signature', createSignatureRibbonButton);
registerButton('doubleSignature', createDoubleSignatureRibbonButton);
registerButton('templates', createTemplatesButton);
registerButton('uploadAudio', uploadAudioButton);
registerButton('record', recordButton);
registerButton('translate', translateReport);
registerButton('addInitialTemplate', addInitialTemplate);
registerButton('lineHeight', lineHeightSelector);
